import React from "react";
import Parser from "html-react-parser";
import { Paragraph } from "@tvg/design-system/web";
import { InfoTextContainer } from "./styled-components";

export interface InfoTextProps {
  content: string;
  isMobile: boolean;
}

const InfoText: React.FC<InfoTextProps> = ({ content, isMobile }) => (
  <InfoTextContainer isMobile={isMobile}>
    <Paragraph color="--fd-colors-content-strong" fontFamily="medium">
      {Parser(content)}
    </Paragraph>
  </InfoTextContainer>
);

export default InfoText;
